import * as stylex from "@stylexjs/stylex";
import { type Breakpoint, layoutSize } from "@/domain/breakpoint";
const PILL_WINDOW = 1400;
const PICKER_INSET = 80;
const PICKER_CELL = {
  min: 36,
  max: 56
} as const;
const styles = {
  root: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "xou54vl",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  large: {
    kOIVth: "x1665zp3",
    $$css: true
  },
  small: {
    kOIVth: "x1665zp3",
    $$css: true
  },
  fit: {
    kZKoxP: "x5yr21d",
    kAzted: "x2lwn1j",
    $$css: true
  },
  scroll: {
    kAzted: "x1us19tq",
    $$css: true
  }
};
export function calendarLayout(breakpoint: Breakpoint, span24: boolean): stylex.StyleXStyles {
  const size = layoutSize(breakpoint);
  const fits = size === "large" && !span24;
  return [styles.root, styles[size], fits ? styles.fit : styles.scroll];
}
export function addEventPill(windowWidth: number): boolean {
  return windowWidth >= PILL_WINDOW;
}
export function pickerCell(windowWidth: number): number {
  const fit = Math.floor((windowWidth - PICKER_INSET) / 7);
  return Math.min(PICKER_CELL.max, Math.max(PICKER_CELL.min, fit));
}